import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/index';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class BackendMetricsService {
  constructor(private _http: HttpClient) {}

  getBackendMetrics(): Observable<any> {
    return this._http.get(`/metrics/lastHour`);
  }
}
